import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Container,
  Column,
  Row,
  Checkbox,
  Button,
  Loader,
  Image,
} from '@mhub/web-components';
import Auth from '@aws-amplify/auth';

import * as storage from '../../utils/storage';
import './styles.css';
import config from '../../config';

const NOTIFICATION_DATA_INIT = {
  id: null,
  title: null,
  imageSrc: null,
  url: null,
  show: false,
};

export default class Notice extends Component {
  static propTypes = {
    onClose: PropTypes.func,
  }

  static defaultProps = {
    onClose: null,
  }

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      ready: false,
      error: false,
      visible: false,
      remind: false,
      data: Object.assign({}, NOTIFICATION_DATA_INIT),
    };
  }

  async getNotification() {
    await this.setStateAsync({ loading: true, ready: false });

    let newData;
    try {
      const res = await fetch(config.endpoints.notificationURL, {
        mode: 'cors',
      });
      newData = await res.json();
    } catch (e) {
      await this.setStateAsync({ loading: false, error: true, ready: true });
      return;
    }

    const data = Object.assign({}, NOTIFICATION_DATA_INIT);
    if (newData) {
      if (newData.imgs && newData.imgs.x010) {
        data.imageSrc = newData.imgs.x010;
      }
      if (newData.id) {
        data.id = newData.id;
      }
      if (newData.title) {
        data.title = newData.title;
      }
      if (newData.url) {
        data.url = newData.url;
      }
      if (newData.show) {
        data.show = newData.show;
      }
    } else {
      await this.setStateAsync({ loading: false, error: true, ready: true });
      return;
    }

    await this.setStateAsync({ loading: false, ready: true, data });
  }

  setStateAsync = (state = {}) => new Promise(res => this.setState(state, () => res(state)))

  handleRemind = () => {
    const { remind } = this.state;
    this.setState({ remind: !remind });
  }

  handleOnOpen = async () => {
  }

  handleDismiss = async () => {
    const { remind, data: { id } } = this.state;
    if (remind) {
      let username = '';
      try {
        ({ username } = await Auth.currentAuthenticatedUser());
      } catch (e) {
        window.bugsnagClient.notify(e);
      }
      storage.setItem(`notice:${username}:${id}`, 'yes');
    }
    await this.setStateAsync({ visible: false });
  }

  continue = async () => {
    await this.setStateAsync({ visible: false });
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  }

  async show() {
    await this.getNotification();

    let username = '';
    try {
      ({ username } = await Auth.currentAuthenticatedUser());
    } catch (e) {
      window.bugsnagClient.notify(e);
    }

    const { ready, data: { id, show } } = this.state;
    if (!ready) {
      await this.continue();
    }
    const remind = storage.getItem(`notice:${username}:${id}`);

    if (show && (!remind || remind === 'yes')) {
      await this.setStateAsync({ visible: true });
      return;
    }
    await this.continue();
  }

  renderContent() {
    const {
      error,
      ready,
      data: { imageSrc, url },
      remind,
    } = this.state;
    return (
      <Container noContent textAlign="center">
        <Row middle center>
          {
            error
              ? (
                <div>
                  <h3>Oops! We&#39;re having trouble loading your notice.</h3>
                  <p>It&#39;s not you. It&#39;s us. Please try again.</p>
                </div>
              )
              : (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this.handleOnOpen}
                >
                  <Image className="Notice-image" src={imageSrc} />
                </a>
              )
          }
        </Row>
        <Row center={!!error} between={!error} className="actions">
          {
            !error && (
              <Checkbox
                onChange={this.handleRemind}
                special
                checked={remind}
              >
                Remind me later
              </Checkbox>
            )
          }
          <Button
            color="blue"
            onClick={this.handleDismiss}
            disabled={!ready}
          >
            Dismiss
          </Button>
        </Row>
      </Container>
    );
  }

  render() {
    const {
      visible,
      loading,
    } = this.state;
    return (
      <Modal
        className="Notice"
        visible={visible}
        onClose={this.continue}
        showCloseButton={false}
        basic
        dimOverlayClickable={false}
      >
        <Row middle center>
          <Column col={12} sm={12} md={8} lg={6}>
            {loading ? <Loader color="white" /> : this.renderContent()}
          </Column>
        </Row>
      </Modal>
    );
  }
}
